var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8211_9491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5574 7.5H12.1253C10.6777 7.5 9.5 8.67755 9.5 10.1253V24.8747C9.5 26.3222 10.6775 27.5 12.1253 27.5H22.8747C24.3223 27.5 25.5 26.3225 25.5 24.8747V13.0244L20.5574 7.5ZM20.903 9.76253L23.4756 12.6378H20.903V9.76253ZM22.8747 26.2491H12.1253C11.7609 26.2486 11.4116 26.1037 11.154 25.846C10.8963 25.5884 10.7514 25.2391 10.7509 24.8747V10.1253C10.7514 9.76093 10.8963 9.41162 11.154 9.15397C11.4116 8.89632 11.7609 8.75138 12.1253 8.75094H19.6521V13.8888H24.2491V24.8747C24.2486 25.2391 24.1037 25.5884 23.846 25.846C23.5884 26.1037 23.2391 26.2486 22.8747 26.2491Z",
    fill: "#F55943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1196 20.7654V15.5H16.8806V20.7654L15.4415 19.0155L14.5 19.8523L17.5 23.5L20.5 19.8523L19.5583 19.0155L18.1196 20.7654Z",
    fill: "#F55943"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8211_9491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(7.5 7.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.e7806750ed2de879dc773fd906005224.svg";
export { ForwardRef as ReactComponent };